import React from 'react';
import ReactDOM from 'react-dom';
import { Switch, Route, BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import registerServiceWorker from './registerServiceWorker';
import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { createLogger } from 'redux-logger'
import surfside from './redux/reducers/reducers'
// Components
import Sidebar from './components/sidebar/sidebar';
import Home from './components/home/home';
import Portfolio from './components/portfolio/portfolio';
import Contact from './components/contact/contact';
import News from './components/news/news';

const loggerMiddleware = createLogger()

let store = createStore(surfside, window.devToolsExtension && window.devToolsExtension(),
applyMiddleware(
  thunkMiddleware,
  loggerMiddleware
));

const Main = () => (
    <main>
      <Switch>
        <Route exact path='/' component={Home}/>
        <Route path='/portfolio' component={Portfolio}/>
        <Route path='/news' component={News}/>
        <Route path='/contact' component={Contact}/>
      </Switch>
    </main>
  )

  const App = () => (
    <div className="d-flex">
      <Sidebar />
      <Main />
    </div>
  )

ReactDOM.render((
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  ), document.getElementById('root'))
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js